import request from '@/utils/request'

let SupplyApi = {
  /*供应商列表*/
   supplyList(data) {
    return request._post('/shop/plus.supply.supply/index', data);
  },
  updateSupplyStatus(data) {
    return request._post('/shop/plus.supply.supply/updateStatus', data);
  },
  getRead(data){
     return request._post('/shop/plus.supply.supply/getRead', data);
  },
  /**
   * 修改商品上下架
   */
  saveStatus(data){
    return request._post('/shop/plus.supply.Product/saveStatus', data);
  },
  saveMembershipFee(data){
     return request._post('/shop/plus.supply.supply/saveMembershipFee', data);
  },
  updateSupplyRead(data){
     return request._post('/shop/plus.supply.supply/updateSupplyRead', data);
  },
  updateProjectRead(data){
     return request._post('/shop/plus.supply.supply/updateProjectRead', data);
  },
   updateInRead(data){
     return request._post('/shop/plus.supply.supply/updateInRead', data);
  },
  updatedlRead(data){
     return request._post('/shop/plus.supply.supply/updatedlRead', data);
  },
  updateRead(data) {
    return request._post('/shop/plus.supply.supply/updateRead', data);
  },
  updateImRead(data) {
    return request._post('/shop/plus.supply.supply/updateImRead', data);
  },
  updateApplyRead(data) {
    return request._post('/shop/plus.supply.supply/updateApplyRead', data);
  },
  updateLogRead(data) {
    return request._post('/shop/plus.supply.supply/updateLogRead', data);
  },
  getUserGrade (data) {
    return request._post('/shop/plus.supply.supply/getUserGrade', data);
  },
   memberList(data) {
    return request._post('/shop/plus.supply_member.Index/index', data);
  },
  auditMember(data) {
    return request._post('/shop/plus.supply_member.Index/audit', data);
  },
  getNoticeList(data){
    return request._post('/shop/plus.supply.Notice/getList', data);
  },
    addNotice(data){
    return request._post('/shop/plus.supply.Notice/add', data);
  },
    editNotice(data){
    return request._post('/shop/plus.supply.Notice/edit', data);
  },
     deleteNotice(data){
    return request._post('/shop/plus.supply.Notice/delete', data);
  },
     changeNoticeStatus(data){
    return request._post('/shop/plus.supply.Notice/status', data);
  },
    list(data) {
      return request._post('/shop/plus.supply_detail.Index/index', data);
  },
  saveAiConfig(data){
     return request._post('/shop/plus.supply.supply/saveai', data);
  },
  detailproduct(data){
      return request._post('/shop/plus.supply.Product/detail', data);
  },
    productlist(data) {
      return request._post('/shop/plus.supply.Product/index', data);
  },
    addProduct(data){
       return request._post('/shop/plus.supply.Product/add', data);
  },
  delproduct(data){
    return request._post('/shop/plus.supply.Product/del', data);
  },
  editProduct(data){
       return request._post('/shop/plus.supply.Product/edit', data);
  },
  /*添加供应商*/
  addSupply(data) {
    return request._post('/shop/plus.supply.supply/add', data);
  },
  /*获取供应商数据*/
  getSupply(data) {
    return request._get('/shop/plus.supply.supply/edit', data);
  },
  getKmdGrade(data){
     return request._get('/shop/plus.supply.supply/getKmdGrade', data);
  },
    /*角色列表*/
    roleLists(data) {
      return request._post('/shop/auth.role/index', data);
    },
  /*保存供应商*/
  saveSupply(data) {
    console.log(data)
    return request._post('/shop/plus.supply.supply/edit', data);
  },
  /*删除供应商*/
  delSupply(data) {
    return request._post('/shop/plus.supply.supply/delete', data);
  },
  /*查看商品*/
  seeSupply(data) {
    return request._post('/shop/plus.supply.supply/see', data);
  },

  /*等级列表*/
  gradeLists(data) {
    return request._post('/shop/plus.supply.grade/index', data);
},
  gradeListsx(data) {
    return request._post('/shop/plus.supply.grade/indexx', data);
},
/*添加等级*/
addgrade(data) {
    return request._post('/shop/plus.supply.grade/add', data);
},
/*修改等级*/
editGrade(data) {
    return request._post('/shop/plus.supply.grade/edit', data);
},
/*删除等级*/
deletegrade(data) {
    return request._post('/shop/plus.supply.grade/delete', data);
},

  /*保存设置*/
  saveSetting(data) {
    return request._post('/shop/plus.supply.Setting/index', data);
  },
  /*获取设置*/
  getSetting(data) {
    return request._get('/shop/plus.supply.Setting/index', data);
  },
  /*获取设置*/
    getDiySkill(data) {
    return request._post('/shop/plus.supply.supply/getDiyProduct', data);
},
 /* 行业列表 */
 categoryList(data,errorback){
  return request._post('/shop/plus.supply.category/index', data, errorback);
},
/* 添加名片分类 */
addCategory(data, errorback) {
  return request._post('/shop/plus.supply.category/add', data, errorback);
},

editCategory(data, errorback) {
  return request._post('/shop/plus.supply.category/edit', data, errorback);
},
delCategory(data, errorback) {
  return request._post('/shop/plus.supply.category/delete', data, errorback);
},
}
export default SupplyApi;



// WEBPACK FOOTER //
// ./src/api/supply.js